import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { adminApi, getToken, setToken } from '../api';

const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);

export function AdminProvider({ children }) {
  const [auth, setAuth] = useState({ status: getToken() ? 'checking' : 'anon', email: null });
  const [tree, setTree] = useState(null);

  const refreshTree = useCallback(() => adminApi.tree().then((t) => { setTree(t); return t; }), []);

  const check = useCallback(async () => {
    if (!getToken()) { setAuth({ status: 'anon', email: null }); return; }
    try {
      const me = await adminApi.me();
      setAuth({ status: 'admin', email: me.email });
      await refreshTree();
    } catch (e) {
      if (e.status === 403) setAuth({ status: 'forbidden', email: null });
      else { setToken(null); setAuth({ status: 'anon', email: null }); }
    }
  }, [refreshTree]);

  useEffect(() => { check(); }, [check]);

  const login = useCallback(async (email, password) => {
    const res = await adminApi.signIn(email, password);
    if (!res?.jwt) throw new Error(res?.error || 'Sign in failed');
    setToken(res.jwt);
    await check();
  }, [check]);

  const logout = useCallback(() => {
    setToken(null);
    setTree(null);
    setAuth({ status: 'anon', email: null });
  }, []);

  return (
    <AdminContext.Provider value={{ auth, login, logout, tree, refreshTree }}>
      {children}
    </AdminContext.Provider>
  );
}
